import { z } from 'zod/mini'

/** データ分類のzodスキーマ（AppMaster取得値） */
export const DataClassificationSchema = z.object({
  DataClassificationCode: z.string(),
  DataClassificationName: z.string()
})

/** @typedef {import('zod/mini').infer<typeof DataClassificationSchema>} DataClassification */

/** データ項目のzodスキーマ（AppMaster取得値） */
export const DataColumnSchema = z.object({
  DataClassificationCode: z.string(),
  ColumnCode: z.string(),
  ColumnName: z.string()
})

/** @typedef {import('zod/mini').infer<typeof DataColumnSchema>} DataColumn */

/** 判定ルールの条件式と判定結果のzodスキーマ */
export const JudgmentRuleItemSchema = z.object({
  condition: z.string(),
  result: z.string()
})

/** @typedef {import('zod/mini').infer<typeof JudgmentRuleItemSchema>} JudgmentRuleItem */

/** 判定ルール登録・更新リクエスト用の1件スキーマ（Condition / Value / ConditionExpression） */
export const JudgmentRuleRequestItemSchema = z.object({
  Condition: z.string(),
  Value: z.string(),
  ConditionExpression: z.string()
})

/** @typedef {import('zod/mini').infer<typeof JudgmentRuleRequestItemSchema>} JudgmentRuleRequestItem */

/** DynamoDB判定ルールレコードのzodスキーマ */
export const JudgmentRuleSchema = z.object({
  CorporationNumber: z.string(),
  RuleId: z.string(),
  RuleName: z.optional(z.string()),
  ValidStartDate: z.optional(z.string()),
  ValidEndDate: z.optional(z.string()),
  ValidStartMonth: z.optional(z.string()),
  ValidEndMonth: z.optional(z.string()),
  /** 期間種別（API は "monthly" / "quarter" / "year"）。対象期間プルダウンの初期選択に使用 */
  PeriodKind: z.nullish(z.string()),
  DataKindName: z.optional(z.string()),
  DataKindCode: z.optional(z.string()),
  ChrofyColumnName: z.optional(z.string()),
  ChrofyColumnCode: z.optional(z.string()),
  /** 旧形式: { condition, result } または 新形式: { Condition, Value, ConditionExpression }（最後1件はelse） */
  JudgmentRules: z.optional(z.array(z.record(z.string(), z.unknown()))),
  ElseResult: z.optional(z.string()),
  CreateUserName: z.optional(z.string()),
  CreateDateTime: z.optional(z.string()),
  UpdateDateTime: z.optional(z.string()),
  Status: z.optional(z.array(z.string()))
})

/** @typedef {import('zod/mini').infer<typeof JudgmentRuleSchema>} JudgmentRule */

/** 判定ルール登録・更新リクエストのzodスキーマ */
export const JudgmentRuleRequestSchema = z.object({
  RuleId: z.optional(z.string()),
  RuleName: z.string(),
  ValidStartMonth: z.optional(z.string()),
  ValidEndMonth: z.optional(z.string()),
  PeriodKind: z.optional(z.string()),
  DataKindName: z.string(),
  DataKindCode: z.optional(z.string()),
  ChrofyColumnName: z.string(),
  ChrofyColumnCode: z.optional(z.string()),
  JudgmentRules: z.array(JudgmentRuleRequestItemSchema)
})

/** @typedef {import('zod/mini').infer<typeof JudgmentRuleRequestSchema>} JudgmentRuleRequest */
